import { render, staticRenderFns } from "./MarketplaceRecommend.vue?vue&type=template&id=e5a2e876&scoped=true"
import script from "./MarketplaceRecommend.vue?vue&type=script&lang=js"
export * from "./MarketplaceRecommend.vue?vue&type=script&lang=js"
import style0 from "./MarketplaceRecommend.vue?vue&type=style&index=0&id=e5a2e876&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5a2e876",
  null
  
)

export default component.exports